import React, { PropTypes } from 'react';

export default function Form() {
  return (
    <form
      className="p-detail-form"
      method="POST"
      name="contact"
      action="/thanks"
      data-netlify={true}
      data-netlify-honeypot="bot-field"
    >
      {/* 迷惑メール対策で以下を追加 */} 
      <input type="hidden" name="bot-field" />

      {/* netlifyが追加する以下のタグをgatsbyが消してしまうため追加 */} 
      <input type="hidden" name="form-name" value="contact" />

      <label>
        <div>お問い合わせの種類 [必須]</div>
        <select name="type" required>
          <option>選択してください</option>
          <option value="キッチンを利用したい">キッチンを利用したい</option>
          <option value="コワーキングスペースを利用したい">コワーキングスペースを利用したい</option>
          <option value="その他">その他</option>
        </select>
      </label>

      <label>
        <div>氏名 [必須]</div>
        <input type="text" name="name" placeholder="例：山田 太郎" required />
      </label>

      <label>
        <div>氏名（カナ） [必須]</div>
        <input type="text" name="kana" placeholder="例：ヤマダ タロウ" required />
      </label>

      <label>
        <div>メールアドレス [必須]</div>
        <input type="email" name="email" placeholder="例：taro@example.com" required />
      </label>

      <label>
        <div>電話番号 [必須]</div>
        <input type="tel" name="tel" placeholder="例：080-1234-5678" required />
      </label>

      <label>
        <div>お問い合わせ内容 [必須]</div>
        <textarea name="content" rows="10" placeholder="お問い合わせ内容をご記入ください" required />
      </label>

      <input type="submit" value="送信する" className="c-button -secondary -full -top" />
    </form>
  );
}



// WEBPACK FOOTER //
// ./src/components/form.js